import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";

class CustomDataTable extends Component {
  render() {
    return (
      <React.Fragment>
        <MDBDataTable
          responsive
          striped
          bordered
          data={this.props.data}
          noBottomColumns
        />
      </React.Fragment>
    );
  }
}

export default CustomDataTable;
